var map = {
	"./1.1.png": "55ed",
	"./1.2.png": "1f3c",
	"./1.3.png": "e844",
	"./2.1.png": "bd34",
	"./3.1.png": "5541",
	"./3.2.png": "5cbf",
	"./4.1.png": "dac2",
	"./4.2.png": "981e",
	"./4.3.png": "d30c",
	"./black_and_yellow_smoke.png": "3560",
	"./codeine.png": "9af1",
	"./demerol.png": "59c4",
	"./dilaudid.png": "70e2",
	"./fentanyl.png": "9933",
	"./hydrocodone.png": "7143",
	"./methadone.png": "603a",
	"./morphine.png": "28ce",
	"./mscontin.png": "c323",
	"./opioid_bottom_picture.png": "35dd",
	"./opioid_pills.png": "5bc1",
	"./opioid_pills_updated.png": "29d8",
	"./oxycontin.png": "a838",
	"./percocet.png": "f889"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";